import styled from "styled-components";

export const StyledContact = styled.div`
  margin-bottom: 35px;

  .contact{
    margin: 50px 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 110px;

    .contact__main{
     margin-left: 70px;
            .contact__header{

                .contact__title{
                    font-weight: 800;
                    font-size: 55px;
                    line-height: 80px;
                    color: #080055;
                }

                .contact__desc{
                    font-weight: 400;
                    font-size: 18px;
                    line-height: 32px;
                    color: #18191F;
                    margin-bottom: 40px;
                }
            }

            .contact__media{
                display: flex;
            align-items: center;
            justify-content: space-between;
            width: 200px;
                .Fb{
                    background: #1877F2;
                    padding: 10px;
                border-radius: 5px;
                :hover{
                            box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
                          }
                }
                .Twttr{
                    background: #1DA1F2;
                    padding: 10px;
                    border-radius: 5px;
                    :hover{
                            box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
                          }
                }
                .In{
                    padding: 10px;
                    border-radius: 5px;
                    background: #2867B2;
                    :hover{
                            box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
                          }
                }
                .Ig{
                    background: #F00073;
                    padding: 10px;
                    border-radius: 5px;
                    :hover{
                            box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
                          }
                }
            }
        }

        .contact__form {
           margin-right: 120px;
           :hover{
                            box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
                          }
        }
    }

    .access{
        background: #0A2538;
        margin-top: 30px 50px;
        display: flex;
        align-items: center;
        justify-content: space-evenly;
         padding: 50px 50px;
        .access__title{
            margin-left: 40px;
            p{
                font-weight: 400;
                font-size: 24px;
                line-height: 43px;
                color: #FFFFFF;
            }
           span{
            width: 60%;
            word-wrap: normal;
            font-weight: 800;
            font-size: 45px;
            line-height: 60px;
            color: #FFFFFF;
           }
         }
       
        .signin__btn{
            margin-right: -50px;
            width: 40%;
           
        }
    }

    
    @media (min-width: 992px) {
        .contact{
        margin: 50px 20px;

            .contact__main{
                margin-left: 60px;
                padding: 0px 20px;
                /* padding: 0px 20px; */
            }
        }
    }
    @media (max-width:900px ) {
       .access{
        min-width: 800px;
       }  
       .contact{
        padding: 50px 40px;
        flex-direction: column;
        align-items: center;
        justify-content: center;
          .contact__main{
            align-items: center;
            margin-left: 120px;
          margin-right: auto;
          width: 100%;
          }
            .contact__form{
                width: 100%;
                margin-top: 40px;
          margin-left: 60px;
          margin-right: auto;
        }
    }
    }
`